export default {
  app: {
    name: "หนังสือกีฬา",
    full: "Back Office Template",
    minimized: "BO"
  },
  no_records: "ไม่มีการบันทึก",
  welcome: "ยินดีต้อนรับกลับ, {user}!",
  login: "โปรดเข้าสู่ระบบเพื่อจะดำเนินการต่อ",
  login_success: "ลงชื่อเข้าใช้สำเร็จแล้ว",
  relogin: "โปรดลงชื่อเข้าใช้บัญชีของคุณอีกครั้ง.",
  expired: "คุณได้ออกจากระบบเนื่องจากการเข้าสู่ระบบหลายครั้ง!",
  denied: "ปฏิเสธการอนุญาต!",
  success: "คุณได้ดำเนินการเรียบร้อยแล้ว!",
  select_date_range: "กรุณาเลือกวันที่",
  permission_denied: "คุณไม่ได้รับอนุญาตให้ดำเนินการนี้!",
  search_by_id_name: "ค้นหาด้วย ID หรือชื่อ",
  search_by_name: "ค้นหาตามชื่อ",
  close: "บัญชีถูกปิด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ",
  suspend: "บัญชีถูกระงับ! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ.",
  suspend_alert1: "บัญชีของคุณเปลี่ยนเป็น VIEW เท่านั้น.",
  suspend_alert2: "โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ.",
  freeze: "บัญชีถูกอายัด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ",
  account_id_length_error: "ความยาว ID บัญชีไม่ถูกต้อง",
  change_user_status_confirm: "คุณต้องการอัปเดตสถานะบัญชีหรือไม่",
  delete_confirm: "Are you sure you want to delete \"{name}\"?",
  update_account_status_confirm: "คุณต้องการอัปเดตสถานะบัญชีหรือไม่",
  update_account_status_cancel: "ไม่สามารถอัปเดตสถานะบัญชี",
  update_account_status_success: "อัปเดตสถานะบัญชีสำเร็จแล้ว!",
  update_account_password_confirm: "คุณต้องการอัปเดตรหัสผ่านบัญชีหรือไม่",
  update_account_password_cancel: "การอัปเดตรหัสผ่านบัญชีล้มเหลว.",
  update_account_password_success: "อัปเดตรหัสผ่านสำเร็จแล้ว!",
  update_account_security_confirm: "คุณแน่ใจหรือไม่ว่าต้องการอัปเดตความปลอดภัยของบัญชี?",
  update_account_security_cancel: "การอัปเดตความปลอดภัยของบัญชีล้มเหลว",
  update_account_security_success: "อัปเดตความปลอดภัยของบัญชีสำเร็จแล้ว!",
  update_account_authority_confirm: "Are you sure want to update account authority?",
  update_account_authority_cancel: "Update account authority failed.",
  update_account_authority_success: "Account authority successfully updated!",
  block_sub_account_confirm: "Are you sure want to block sub account?",
  block_sub_account_cancel: "Block sub account failed.",
  block_sub_account_success: "Sub account successfully blocked!",
  unblock_sub_account_confirm: "Are you sure want to unblock sub account?",
  unblock_sub_account_cancel: "Unblock sub account failed.",
  unblock_sub_account_success: "Sub account successfully unblocked!",
  successful_update_profile: "You have successfully update profile.",
  successful_update_security: "You have successfully update security code.",
  successful_create_account: "คุณสร้างบัญชีใหม่สำเร็จแล้ว",
  update_platform_settings_confirm: "Are you sure want to update platform settings?",
  update_platform_settings_cancel: "Update platform settings failed.",
  update_platform_settings_success: "Platform settings successfully updated!",
  reset_accumulate_win_confirm: "Are you sure want to reset accumualte win limit?",
  reset_accumulate_win_cancel: "Reset accumulate win limit failed.",
  reset_accumulate_win_success: "Accumulate win limit successfully reset!",
  parent_platform_disabled: "Upline platform settings has been disabled.",
  copy_success: "The account information has been copied to clipboard.",
  copy_failed: "Your browser doesn't support copied to clipboard.",
  copy_all_upline: "Copy soccer HDP upline to all sport types",
  copy_all_account: "Copy soccer HDP account to all sport types",
  copy_all_remaining: "Copy soccer HDP remaining to all sport types",
  copy_all_min: "Copy soccer HDP min to all sport types",
  copy_all_min_bet: "Copy soccer min bet to all sport types",
  copy_all_max_bet: "Copy soccer max bet to all sport types",
  copy_all_max_per_match: "Copy soccer max per match to all sport types",
  create_secondary_account_success: "Secondary account successfully created! Please relogin again.",
  first_sub_account_success: "Sub account successfully updated! Please relogin again.",
  update_account_commission_confirm: "Are you sure want to update account commission?",
  update_account_commission_cancel: "Update account commission failed.",
  update_account_commission_success: "Account commission successfully updated!",
  update_account_position_confirm: "Are you sure want to update account position taking?",
  update_account_position_cancel: "Update account position taking failed.",
  update_account_position_success: "Account position taking successfully updated!",
  update_account_bet_limit_confirm: "Are you sure want to update account bet limit?",
  update_account_bet_limit_cancel: "Update account bet limit failed.",
  update_account_bet_limit_success: "Account bet limit successfully updated!",
  update_account_profile_confirm: "Are you sure want to update account profile?",
  update_account_profile_cancel: "Update account profile failed.",
  update_account_profile_success: "Account profile successfully updated!",
  create_new_account_confirm: "Are you sure want to create new account?",
  create_new_account_cancel: "Create new account failed",
  create_new_account_success: "New account successfully created!",
  create_sub_account_confirm: "Are you sure want to create sub account?",
  create_sub_account_cancel: "Create sub account failed",
  create_sub_account_success: "Sub account successfully created!",
  update_sub_account_confirm: "Are you sure want to update sub account?",
  update_sub_account_cancel: "Update sub account failed",
  update_sub_account_success: "Sub account successfully updated!",
  unblock_account_profile_confirm: "Are you sure want to unblock account profile?",
  unblock_account_profile_cancel: "Unblock account profile failed.",
  unblock_account_profile_success: "Account profile successfully unblocked!",
  settlement_confirm: "Are you sure want to proceed settlement?",
  settlement_cancel: "Settlement failed",
  settlement_success: "Settlement successfully processed!",
  settlement_not_allowed: "Settlement is not allowed today!",
  search_with_working_date: "Search with working date",
  system_error: "ระบบไม่สามารถดำเนินการตามคำขอของคุณ.",
  invalid_password: "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
  invalid_account: "บัญชีไม่ถูกต้อง.",
  block: "Your account has been blocked.",
  invalid_security_code: "Invalid security code.",
  source_account_id_required: "Account ID is required.",
  target_account_id_required: "Target account ID is required.",
  account_id_required: "Account ID is required.",
  sub_login_id_required: "Login ID is required.",
  account_not_exists: "Invalid account.",
  profile_not_exists: "Invalid account.",
  account_inactive: "Inactive account.",
  not_blocked_account: "Valid account.",
  password_required: "Password is required.",
  parent_id_required: "Parent ID is required.",
  parent_not_exists:"Invalid account.",
  invalid_account_type: "Invalid account type.",
  account_exists: "Account is already exists.",
  login_id_required: "Login ID is required.",
  new_login_id_required: "New login ID is required.",
  login_id_not_exists: "Invalid login ID.",
  invalid_authority_role: "Invalid role.",
  profile_inactive: "Invalid profile.",
  secondary_account_exists: "Secondary account is already exists.",
  new_login_id_exists: "New login ID is already exists.",
  new_password_required: "New password is required.",
  security_tag_required: "Security tag is required.",
  security_code_required: "Security code is required.",
  start_date_required: "Start date is required.",
  end_date_required: "End date is required.",
  start_date_gt_end_date: "Start date is greater than end date.",
  start_date_greater_end_date: "Start date is greater than end date.",
  member_id_required: "Member ID is required.",
  currency_code_required: "Currency code is required.",
  commission_setting_not_exists: "Commission setting does not exists.",
  incomplete_account_line: "Incomplete account line.",
  invalid_hdp_package: "Invalid HDP packages.",
  search_id_required: "Search ID is required.",
  profile_id_required: "Profile ID is required.",
  login_not_exists: "Invalid login ID.",
  no_changes: "There is no changes detected.",
  start_date_require: "Start date is required.",
  league_id_required: "League ID is required.",
  sport_type_required: "Sport Type is reuired.",
  match_id_required: "Match ID is required.",
  target_login_id_required: "Target login ID is required.",
  parent_account_not_exists: "Invalid account.",
  parent_account_inactive: "Inactive parent account.",
  parent_profile_not_exists: "Invalid account..",
  parent_profile_inactive: "Inactive parent profile.",
  target_login_id_not_exists: "Invalid account.",
  incorrect_parent: "Invalid parent ID.",
  invalid_session: "Invalid session request.",
  session_expired: "Session expired.",
  settle_amount_required: "Settle amount is required.",
  invalid_settle_amount: "Invalid settle amount.",
  settle_amount_gt_yesterday_balance: "Settle amount is greater than yesterday balance.",
  invalid_account_status: "Invalid account status.",
  bet_limit_packages_required: "Bet limit packages are required.",
  bet_limit_exists: "Bet limit is already exists.",
  member_bet_limit_package_gt_one: "Member bet limit packages is more than one.",
  parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  account_commission_required: "Account commission is required.",
  commission_setting_exists: "Commission setting already exists.",
  parent_comm_not_exists: "Parent commission setting does not exits.",
  exceeded_parent_comm: "Exceeded parent commission setting.",
  others_commission_required: "Others commission setting is required.",
  exceeded_parent_1x2: "Exceeded parent 1x2 commission setting.",
  exceeded_parent_other: "Exceeded parent other commission setting.",
  hdp_commission_required: "HDP commission setting is required.",
  exceeded_parent_hdp_a: "Exceeded parent HPD(A) commission setting.",
  exceeded_parent_hdp_b: "Exceeded parent HPD(B) commission setting.",
  exceeded_parent_hdp_c: "Exceeded parent HPD(C) commission setting.",
  exceeded_parent_hdp_d: "Exceeded parent HPD(D) commission setting.",
  exceeded_parent_hdp_e: "Exceeded parent HPD(E) commission setting.",
  exceeded_parent_hdp_f: "Exceeded parent HPD(F) commission setting.",
  exceeded_parent_hdp_g: "Exceeded parent HPD(G) commission setting.",
  exceeded_parent_hdp_h: "Exceeded parent HPD(H) commission setting.",
  exceeded_parent_hdp_i: "Exceeded parent HPD(I) commission setting.",
  exceeded_parent_hdp_j: "Exceeded parent HPD(J) commission setting.",
  livecasino_upline_pt_required: "[Livecasino] Upline PT setting is required.",
  livecasino_pt_setting_exists: "[Livecasino] PT setting is required.",
  livecasino_parent_pt_not_exists: "[Livecasino] Parent PT setting does not exists.",
  livecasino_parent_min_not_meet: "[Livecasino] Does not match with parent minimum PT.",
  livecasino_exceeded_parent_pt: "[Livecasino] Exceeded parent PT setting.",
  livecasino_account_pt_required: "[Livecasino] Account PT setting is required.",
  livecasino_upline_remaining_required: "[Livecasino] Upline remaining PT setting is required.",
  livecasino_account_min_required: "[Livecasino] Account minimum PT setting is required.",
  livecasino_upline_remaining_gt_account_pt: "[Livecasino] Upline remaining PT setting is greater than account PT setting.",
  livecasino_account_min_gt_p: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  slots_upline_pt_required: "[Slots] Upline PT setting is required.",
  slots_pt_setting_exists: "[Slots] PT setting is required.",
  slots_parent_pt_not_exists: "[Slots] Parent PT setting does not exists.",
  slots_parent_min_not_meet: "[Slots] Does not match with parent minimum PT.",
  slots_exceeded_parent_pt: "[Slots] Exceeded parent PT setting.",
  slots_account_pt_required: "[Slots] Account PT setting is required.",
  slots_upline_remaining_required: "[Slots] Upline remaining PT setting is required.",
  slots_account_min_required: "[Slots] Account minimum PT setting is required.",
  slots_upline_remaining_gt_account_pt: "[Slots] Upline remaining PT setting is greater than account PT setting.",
  slots_account_min_gt_pt: "[Slots] Account minimum PT setting is greater than parent PT setting.",
  lotto_upline_pt_required: "[Lotto] Upline PT setting is required.",
  lotto_pt_setting_exists: "[Lotto] PT setting is required.",
  lotto_parent_pt_not_exists: "[Lotto] Parent PT setting does not exists.",
  lotto_parent_min_not_meet: "[Lotto] Does not match with parent minimum PT.",
  lotto_exceeded_parent_pt: "[Lotto] Exceeded parent PT setting.",
  lotto_account_pt_required: "[Lotto] Account PT setting is required.",
  lotto_upline_remaining_required: "[Lotto] Upline remaining PT setting is required.",
  lotto_account_min_required: "[Lotto] Account minimum PT setting is required.",
  lotto_upline_remaining_gt_account_pt: "[Lotto] Upline remaining PT setting is greater than account PT setting.",
  lotto_account_min_gt_pt: "[Lotto] Account minimum PT setting is greater than parent PT setting.",
  keno_upline_pt_required: "[Keno] Upline PT setting is required.",
  keno_pt_setting_exists: "[Keno] PT setting is required.",
  keno_parent_pt_not_exists: "[Keno] Parent PT setting does not exists.",
  keno_parent_min_not_meet: "[Keno] Does not match with parent minimum PT.",
  keno_exceeded_parent_pt: "[Keno] Exceeded parent PT setting.",
  keno_account_pt_required: "[Keno] Account PT setting is required.",
  keno_upline_remaining_required: "[Keno] Upline remaining PT setting is required.",
  keno_account_min_required: "[Keno] Account minimum PT setting is required.",
  keno_upline_remaining_gt_account_pt: "[Keno] Upline remaining PT setting is greater than account PT setting.",
  keno_account_min_gt_pt: "[Keno] Account minimum PT setting is greater than parent PT setting.",
  cockfight_upline_pt_required: "[Cockfight] Upline PT setting is required.",
  cockfight_pt_setting_exists: "[Cockfight] PT setting is required.",
  cockfight_parent_pt_not_exists: "[Cockfight] Parent PT setting does not exists.",
  cockfight_parent_min_not_meet: "[Cockfight] Does not match with parent minimum PT.",
  cockfight_exceeded_parent_pt: "[Cockfight] Exceeded parent PT setting.",
  cockfight_account_pt_required: "[Cockfight] Account PT setting is required.",
  cockfight_upline_remaining_required: "[Cockfight] Upline remaining PT setting is required.",
  cockfight_account_min_required: "[Cockfight] Account minimum PT setting is required.",
  cockfight_upline_remaining_gt_account_pt: "[Cockfight] Upline remaining PT setting is greater than account PT setting.",
  cockfight_account_min_gt_pt: "[Cockfight] Account minimum PT setting is greater than parent PT setting.",
  lottery_upline_pt_required: "[Lottery] Upline PT setting is required.",
  lottery_pt_setting_exists: "[Lottery] PT setting is required.",
  lottery_parent_pt_not_exists: "[Lottery] Parent PT setting does not exists.",
  lottery_parent_min_not_meet: "[Lottery] Does not match with parent minimum PT.",
  lottery_exceeded_parent_pt: "[Lottery] Exceeded parent PT setting.",
  lottery_account_pt_required: "[Lottery] Account PT setting is required.",
  lottery_upline_remaining_required: "[Lottery] Upline remaining PT setting is required.",
  lottery_account_min_required: "[Lottery] Account minimum PT setting is required.",
  lottery_upline_remaining_gt_account_pt: "[Lottery] Upline remaining PT setting is greater than account PT setting.",
  lottery_account_min_gt_pt: "[Lottery] Account minimum PT setting is greater than parent PT setting.",
  bet_type_required: "Bet type is required",
  schedule_1_to_7_required: "Settlement schedule is required",
  schedule_exists: "Settlement schedule does not exists.",
  parent_schedule_not_exists: "Parent settlement schedule does not exists.",
  schedule_1_not_available: "Settlement on Monday is not available.",
  schedule_2_not_available: "Settlement on Tuesday is not available.",
  schedule_3_not_available: "Settlement on Wednesday is not available.",
  schedule_4_not_available: "Settlement on Thursday is not available.",
  schedule_5_not_available: "Settlement on Friday is not available.",
  schedule_6_not_available: "Settlement on Saturday is not available.",
  schedule_7_not_available: "Settlement on Sunday is not available.",
  credit_limit_required: "Credit limit is required.",
  member_credit_limit_required: "Member credit limit is required.",
  wallet_exists: "Account is already exists.",
  member_credit_limit_gt_credit_limit: "Member credit limit is greater than credit limit.",
  parent_wallet_not_exists: "Account does not exists.",
  account_credit_limit_gt_parent: "Account credit limit is greater than parent credit limit.",
  member_credit_limit_gt_parent: "Member credit limit is greater than parent credit limit",
  exceeded_credit_limit: "Exceeded account credit limit.",
  soccer_min_bet_required: "Minimum bet is required.",
  soccer_max_bet_required: "Maximum bet is required.",
  soccer_max_per_match_required: "Maximum bet per match is required",
  soccer_bet_limit_exists: "Bet limit is already exists.",
  soccer_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  soccer_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  soccer_account_max_bet_gt_parent: "Account max bet is greater than parent",
  soccer_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  basketball_min_bet_required: "Minimum bet is required.",
  basketball_max_bet_required: "Maximum bet is required.",
  basketball_max_per_match_required: "Maximum bet per match is required",
  basketball_bet_limit_exists: "Bet limit is already exists.",
  basketball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  basketball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  basketball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  basketball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  tennis_min_bet_required: "Minimum bet is required.",
  tennis_max_bet_required: "Maximum bet is required.",
  tennis_max_per_match_required: "Maximum bet per match is required",
  tennis_bet_limit_exists: "Bet limit is already exists.",
  tennis_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  tennis_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  tennis_account_max_bet_gt_parent: "Account max bet is greater than parent",
  tennis_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  baseball_min_bet_required: "Minimum bet is required.",
  baseball_max_bet_required: "Maximum bet is required.",
  baseball_max_per_match_required: "Maximum bet per match is required",
  baseball_bet_limit_exists: "Bet limit is already exists.",
  baseball_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  baseball_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  baseball_account_max_bet_gt_parent: "Account max bet is greater than parent",
  baseball_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  parlay_min_bet_required: "Minimum bet is required.",
  parlay_max_bet_required: "Maximum bet is required.",
  parlay_max_per_match_required: "Maximum bet per match is required",
  parlay_bet_limit_exists: "Bet limit is already exists.",
  parlay_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  parlay_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  parlay_account_max_bet_gt_parent: "Account max bet is greater than parent",
  parlay_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  esports_min_bet_required: "Minimum bet is required.",
  esports_max_bet_required: "Maximum bet is required.",
  esports_max_per_match_required: "Maximum bet per match is required",
  esports_bet_limit_exists: "Bet limit is already exists.",
  esports_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  esports_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  esports_account_max_bet_gt_parent: "Account max bet is greater than parent",
  esports_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  others_min_bet_required: "Minimum bet is required.",
  others_max_bet_required: "Maximum bet is required.",
  others_max_per_match_required: "Maximum bet per match is required",
  others_bet_limit_exists: "Bet limit is already exists.",
  others_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  others_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  others_account_max_bet_gt_parent: "Account max bet is greater than parent",
  others_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  cs_min_bet_required: "Minimum bet is required.",
  cs_max_bet_required: "Maximum bet is required.",
  cs_max_per_match_required: "Maximum bet per match is required",
  cs_bet_limit_exists: "Bet limit is already exists.",
  cs_parent_bet_limit_not_exists: "Parent bet limit does not exists.",
  cs_account_min_bet_lt_parent: "Account min bet is lower than parent.",
  cs_account_max_bet_gt_parent: "Account max bet is greater than parent",
  cs_account_max_per_match_gt_parent: "Account maximum bet per match is greater than parent.",
  used_credit_gt_credit_limit: "Used credit limit is greater than credit limit.",
  bet_limit_setting_not_exists: "Bet limit setting does not exists.",
  parent_bet_limit_setting_not_exists: "Parent bet limit setting does not exists.",
  package_not_exists_in_parent: "Parent bet limit package setting does not exists",
  soccer_bet_limit_setting_not_exists: "Soccer bet limit setting does not exixts.",
  soccer_update_interval_violated: "Update interval violated.",
  basketball_bet_limit_setting_not_exists: "Basketball bet limit setting does not exixts.",
  basketball_update_interval_violated: "Update interval violated.",
  tennis_bet_limit_setting_not_exists:"Tennis bet limit setting does not exixts.",
  tennis_update_interval_violated: "Update interval violated.",
  baseball_bet_limit_setting_not_exists:"Baseball bet limit setting does not exixts.",
  baseball_update_interval_violated: "Update interval violated.",
  parlay_bet_limit_setting_not_exists:"Parlay bet limit setting does not exixts.",
  parlay_update_interval_violated: "Update interval violated.",
  esports_bet_limit_setting_not_exists:"Esports bet limit setting does not exixts.",
  esports_update_interval_violated: "Update interval violated.",
  others_bet_limit_setting_not_exists:"Others bet limit setting does not exixts.",
  others_update_interval_violated: "Update interval violated.",
  cs_bet_limit_setting_not_exists:"Correct Score bet limit setting does not exixts.",
  cs_update_interval_violated: "Update interval violated.",
  soccer_parent_bet_limit_setting_not_exists: "Soccer parent bet limit setting does not exixts.",
  soccer_min_bet_lt_parent: "Soccer account min bet is lower than parent.",
  soccer_max_bet_gt_parent: "Soccer account max bet is greater than parent.",
  soccer_max_per_match_gt_parent: "Soccer account max per match is greater than parent.",
  basketball_parent_bet_limit_setting_not_exists: "Basketball parent bet limit setting does not exixts.",
  basketball_min_bet_lt_parent: "Basketball account min bet is lower than parent.",
  basketball_max_bet_gt_parent: "Basketball account max bet is greater than parent.",
  basketball_max_per_match_gt_parent: "Basketball account max per match is greater than parent.",
  tennis_parent_bet_limit_setting_not_exists: "Tennis parent bet limit setting does not exixts.",
  tennis_min_bet_lt_parent: "Tennis account min bet is lower than parent.",
  tennis_max_bet_gt_parent: "Tennis account max bet is greater than parent.",
  tennis_max_per_match_gt_parent: "Tennis account max per match is greater than parent.",
  baseball_parent_bet_limit_setting_not_exists: "Baseball parent bet limit setting does not exixts.",
  baseball_min_bet_lt_parent: "Baseball account min bet is lower than parent.",
  baseball_max_bet_gt_parent: "Baseball account max bet is greater than parent.",
  baseball_max_per_match_gt_parent: "Baseball account max per match is greater than parent.",
  parlay_parent_bet_limit_setting_not_exists: "Parlay parent bet limit setting does not exixts.",
  parlay_min_bet_lt_parent: "Parlay account min bet is lower than parent.",
  parlay_max_bet_gt_parent: "Parlay account max bet is greater than parent.",
  parlay_max_per_match_gt_parent: "Parlay account max per match is greater than parent.",
  esports_parent_bet_limit_setting_not_exists: "ESports parent bet limit setting does not exixts.",
  esports_min_bet_lt_parent: "ESports account min bet is lower than parent.",
  esports_max_bet_gt_parent: "ESports account max bet is greater than parent.",
  esports_max_per_match_gt_parent: "ESports account max per match is greater than parent.",
  others_parent_bet_limit_setting_not_exists: "Others parent bet limit setting does not exixts.",
  others_min_bet_lt_parent: "Others account min bet is lower than parent.",
  others_max_bet_gt_parent: "Others account max bet is greater than parent.",
  others_max_per_match_gt_parent: "Others account max per match is greater than parent.",
  cs_parent_bet_limit_setting_not_exists: "Correct Score parent bet limit setting does not exixts.",
  cs_min_bet_lt_parent: "Correct Score account min bet is lower than parent.",
  cs_max_bet_gt_parent: "Correct Score account max bet is greater than parent.",
  cs_max_per_match_gt_parent: "Correct Score account max per match is greater than parent.",

  cs_min_bet_lt_soccer: "Correct Score account min bet is lower than soccer.",
  cs_max_bet_gt_soccer: "Correct Score account max bet is greater than soccer.",
  cs_max_per_match_gt_soccer: "Correct Score account max per match is greater than soccer.",

  update_interval_violated: "Update interval violated.",
  exceeded_parent_others: "Exceeded parent others commission setting.",
  exceeded_parent_hdp: "Exceeded parent HDP bet limit setting.",
  no_information_available: "No information is available.",
  request_processing: "Processing request...",
  new_login_id_format_error: "Only small capital letters from a to z and 0 to 9 allowed.",
  account_id_format_error: "Only small capital letters from a to z and 0 to 9 allowed.",
  inactive_account: "Account has been closed/suspended. Please contact operator.",

  sportsbook_account_pt_gt_92: "Super Senior PT cannot greater than 92%",
  pending_result: "Pending result",
  insufficient_balance: "Insufficient balance",
  ok: "Succeed",
  settlement_warning: "Warning: if balance is fully transffered, the highlighted members below will have negative bet credit and consequently, they might lose more than their given credit.",
  jackpot_alert: "For any single progressive jackpot payout exceeding MYR 100,000 (THB 1,000,000),  WBET will bear the cost of the full amount.",
  accumulate_alert: "Win limits will reset once payment is settled in transfer list",
  authorityOptionRequired: "Please choose at least one authority",

  add_key_confirm: "Are you sure want to add key?",
  add_key_success: "Key successfully added!",
  update_key_confirm: "Are you sure want to update key?",
  update_key_success: "Key successfully updated!",
  targetAccountIdContainReservedWord: "Username contain reserved words",
  update_bet_limit_setting: "Are you sure want to update bet limit setting?",
  update_bet_limit_setting_cancel: "Update bet limit failed.",
  update_bet_limit_succeed: "Bet limit successfully updated!",

  update_account_hdp_packages_confirm: "Are you sure want to update account hdp packages?",
  update_account_hdp_packages_cancel: "Update account hdp packages failed.",
  update_account_hdp_packages_success: "Account hdp packages successfully updated!",

  cash_deposit_confirm: "Are you sure want to deposit cash?",
  cash_deposit_cancel: "Deposit cash failed.",
  cash_deposit_success: "Deposit cash successfully updated!",

  cash_withdrawal_confirm: "Are you sure want to withdraw cash?",
  cash_withdrawal_cancel: "Withdraw cash failed.",
  cash_withdrawal_success: "Withdraw cash successfully updated!",

  welcome_to_wbet: "Welcome To WBET!",
  invalid_parameter: "Invalid parameter.",
  action_by_required: "Action by is required.",
  invalid_action_by: "Invalid action by.",
  invalid_account_id: "Invalid account ID.",
  invalid_profile_id: "Invalid profile ID.",
  session_token_required: "Session token is required.",
  invalid_session_token: "Invalid session token.",
  invalid_target_account_id: "Invalid target account ID.",
  invalid_search_id: "Invalid search ID.",
  invalid_start_date: "Invalid start date.",
  invalid_end_date: "Invalid end date.",
  invalid_page_number: "Invalid page number.",
  invalid_page_size: "Invalid page size.",
  invalid_account_status: "Invalid account status.",
  invalid_soccer_min_bet: "Invalid min bet.",
  invalid_soccer_max_bet: "Invalid max bet.",
  invalid_soccer_max_per_match: "Invalid maximum bet per match.",
  soccer_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  soccer_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_basketball_min_bet: "Invalid min bet.",
  invalid_basketball_max_bet: "Invalid max bet.",
  invalid_basketball_max_per_match: "Invalid maximum bet per match.",
  basketball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  basketball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_tennis_min_bet: "Invalid min bet.",
  invalid_tennis_max_bet: "Invalid max bet.",
  invalid_tennis_max_per_match: "Invalid maximum bet per match.",
  tennis_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  tennis_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_baseball_min_bet: "Invalid min bet.",
  invalid_baseball_max_bet: "Invalid max bet.",
  invalid_baseball_max_per_match: "Invalid maximum bet per match.",
  baseball_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  baseball_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_parlay_min_bet: "Invalid min bet.",
  invalid_parlay_max_bet: "Invalid max bet.",
  invalid_parlay_max_per_match: "Invalid maximum bet per match.",
  parlay_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  parlay_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_esports_min_bet: "Invalid min bet.",
  invalid_esports_max_bet: "Invalid max bet.",
  invalid_esports_max_per_match: "Invalid maximum bet per match.",
  esports_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  esports_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_others_min_bet: "Invalid min bet.",
  invalid_others_max_bet: "Invalid max bet.",
  invalid_others_max_per_match: "Invalid maximum bet per match.",
  others_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  others_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_cs_min_bet: "Invalid min bet.",
  invalid_cs_max_bet: "Invalid max bet.",
  invalid_cs_max_per_match: "Invalid maximum bet per match.",
  cs_min_bet_gt_max_bet: "Minimum bet is greater than maximum bet.",
  cs_max_bet_gt_max_per_match: "Maximum bet is greater than maximum bet per match.",
  invalid_passwords: "Invalid password.",
  invalid_account_type: "Invalid account type.",
  invalid_full_name: "Invalid full name.",
  invalid_contact_email: "Invalid contact email.",
  invalid_contact_phone: "Invalid contact phone.",
  invalid_audit_by: "Invalid audit by.",
  invalid_remark: "Invalid remark.",
  target_profile_id_required: "Target profile ID is required.",
  invalid_target_profile_id: "Invalid target profile ID.",
  invalid_sub_login_id: "Invalid sub login ID.",
  invalid_sort_key: "Invalid sort key.",
  invalid_sort_type: "Invalid sort type.",
  invalid_new_login_id: "Invalid new login ID.",
  invalid_new_password: "Invalid new password.",
  invalid_security_tag: "Invalid security tag.",
  invalid_security_code: "Invalid security code.",
  authority_option_required: "Please choose at least one authority.",
  invalid_authority_option: "Invalid authority option.",
  ip_required: "IP is required.",
  invalid_ip: "Invalid IP",
  suffix_required: "Suffix is required.",
  invalid_suffix: "Invalid suffix.",
  type_required: "Type is required.",
  invalid_type: "Invalid type.",
  callbackurl_required: "Callbackurl is required.",
  invalid_callbackurl: "Invalid callbackurl.",
  email_required: "Email is required.",
  invalid_email: "Invalid email.",
  apistatus_required: "Apistatus is required.",
  invalid_apistatus: "Invalid apistatus.",
  invalid_login_id: "Invalid login ID.",
  invalid_loginsource: "Invalid login source.",
  hdp_package_required: "HDP package required.",
  invalid_target_login_id: "Invalid target login ID.",
  status_required: "Status is required.",
  invalid_status: "Invalid status.",
  amount_required: "Amount is required.",
  invalid_amount: "Invalid amount.",
  method_required: "Method is required.",
  invalid_method: "Invalid method.",
  soccer_hdp_upline_pt_required: "HDP upline PT is required.",
  soccer_hdp_account_pt_required: "HDP account PT is required.",
  soccer_hdp_upline_remaining_required: "HDP upline remaining is required.",
  soccer_hdp_account_min_required: "HDP account minimum is required.",
  soccer_hdp_pt_setting_not_exists: "HDP PT setting does not exists.",
  soccer_hdp_parent_pt_not_exists: "HDP parent PT does not exists.",
  soccer_hdp_exceeded_parent_pt: "HDP exceeded parent PT.",
  soccer_hdp_upline_remaining_gt_account_pt: "HDP upline remaining greater than account PT.",
  soccer_hdp_account_min_gt_pt: "HDP account minimum greater than PT",
  soccer_hdp_account_pt_lt_downline: "HDP account PT lower than downline.",

  invalid_soccer_hdp_upline_pt: "Invalid HDP upline PT.",
  soccer_1x2_upline_pt_required: "1x2 upline PT is required.",
  soccer_1x2_account_pt_required: "1x2 account PT is required.",
  soccer_1x2_upline_remaining_required: "1x2 upline remaining is required.",
  soccer_1x2_account_min_required: "1x2 account minimum is required.",
  soccer_1x2_pt_setting_not_exists: "1x2 PT setting does not exists.",
  soccer_1x2_parent_pt_not_exists: "1x2 parent PT does not exists.",
  soccer_1x2_exceeded_parent_pt: "1x2 exceeded parent PT.",
  soccer_1x2_upline_remaining_gt_account_pt: "1x2 upline remaining greater than account PT.",
  soccer_1x2_account_min_gt_pt: "1x2 account minimum greater than PT",
  soccer_1x2_account_pt_lt_downline: "1x2 account PT lower than downline.",
  
  invalid_soccer_1x2_upline_pt: "Invalid 1x2 upline PT.",
  soccer_others_upline_pt_required: "Others upline PT is required.",
  soccer_others_account_pt_required: "Others account PT is required.",
  soccer_others_upline_remaining_required: "Others upline remaining is required.",
  soccer_others_account_min_required: "Others account minimum is required.",
  soccer_others_pt_setting_not_exists: "Others PT setting does not exists.",
  soccer_others_parent_pt_not_exists: "Others parent PT does not exists.",
  soccer_others_exceeded_parent_pt: "Others exceeded parent PT.",
  soccer_others_upline_remaining_gt_account_pt: "Others upline remaining greater than account PT.",
  soccer_others_account_min_gt_pt: "Others account minimum greater than PT",
  soccer_others_account_pt_lt_downline: "Others account PT lower than downline.",

  invalid_soccer_others_upline_pt: "Invalid others upline PT.",
  parlay_upline_pt_required: "Parlay upline PT is required.",
  parlay_account_pt_required: "Parlay account PT is required.",
  parlay_upline_remaining_required: "Parlay upline remaining is required.",
  parlay_account_min_required: "Parlay account minimum is required.",
  parlay_pt_setting_not_exists: "Parlay PT setting does not exists.",
  parlay_parent_pt_not_exists: "Parlay parent PT does not exists.",
  parlay_exceeded_parent_pt: "Parlay exceeded parent PT.",
  parlay_upline_remaining_gt_account_pt: "Parlay upline remaining greater than account PT.",
  parlay_account_min_gt_pt: "Parlay account minimum greater than PT",
  parlay_account_pt_lt_downline: "Parlay account PT lower than downline.",

  invalid_parlay_upline_pt: "Invalid parlay upline PT .",
  invalid_member_id: "Invalid member ID.",
  invalid_sport_type: "Invalid sport type.",
  invalid_league_id: "Invalid league ID.",
  invalid_match_id: "Invalid match ID.",
  working_date_required: "Working date is required.",
  invalid_working_date: "Invalid working date.",
  game_type_required: "Game type is required.",
  invalid_game_type: "Invalid game type.",
  bet_id_required: "Bet ID is required.",
  invalid_bet_id: "Invalid bet ID.",
  hdp_packages_not_exists: "HDP package does not exists.",
  parent_hdp_packages_not_exists: "Parent HDP package does not exists.",
  invalid_bet_type: "Invalid bet type.",
  invalid_match_id: "Invalid Match ID.",
  invalid_home_running_score: "Invalid Home Running Score.",
  invalid_away_running_score: "Invalid Away Running Score.",
  invalid_home_away: "Invalid Home Away.",

  operator_account_not_exists: "Operator account does not exists.",
  insert_main_failed: "Insert main failed.",
  delete_child_failed: "Delete child failed.",
  insert_child_failed: "Insert child failed.",
  invalid_operator: "Invalid operator.",
  invalid_master: "Invalid master.",
  duplicate_suffix: "Duplicate suffix.",
  insert_error: "Insert error.",
  allow_to_add_multiple_ip: "Allow to add multiple IP, eg. 192.168.1.1,192.168.1.2",
  only_allow_proper_url: "URL must be start with http or https, eg. https://xxxxxx.com",

  password_length_error: "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร",
  password_whitespace_error: "รหัสผ่านไม่สามารถมีช่องว่างตำแหน่งแรกหรือตำแหน่งสุดท้ายได้",
  password_types_error: "รหัสผ่านต้องมีอย่างน้อย 3 ประเภทตัวอักษร",
  password_consecutive_error: "รหัสผ่านไม่สามารถมีตัวอักษรหรือตัวเลขที่ติดกันได้",
  password_repeated_error: "รหัสผ่านไม่สามารถมีตัวอักษรหรือตัวเลขที่ซ้ำกันได้",
  password_common_error: "รหัสผ่านไม่สามารถมีคำที่คัยใช้กันทั่วไปได้",

  security_code_required: "กรุณากรอกรหัสความปลอดภัย",
  security_code_error: "รหัสความปลอดภัยต้องมีอย่างน้อย 6 ตัวอักษร",
  security_digit_error: "รหัสความปลอดภัยต้องมีอย่างน้อย 2 ตัวอักษรที่แตกต่างกัน",
  security_consecutive_error: "รหัสความปลอดภัยไม่สามารถมีตัวอักษรหรือตัวเลขที่ติดกันได้",
  security_repeated_error: "รหัสความปลอดภัยไม่สามารถมีตัวอักษรหรือตัวเลขที่ซ้ำกันได้",
  security_palindrome_error: "รหัสความปลอดภัยไม่สามารถมีตัวอักษรหรือตัวเลขที่ซ้ำกันได้",
  security_weak_error: "รหัสความปลอดภัยต้องมีอย่างน้อย 6 ตัวอักษร",
  security_code_example: "ตัวอย่างเช่น 123456, 765432, 456789 เป็นต้น ไม่อนุญาต",

  // OTP 2FA Messages
  other_authenticator_apps_supported: "แอปยืนยันตัวตนแบบสองขั้นตอนอื่นๆ เช่น Sophos, Microsoft Authenticator เป็นต้น ก็รองรับเช่นกัน",
  date_time_automatic_required: "การตั้งค่าวันที่และเวลาบนอุปกรณ์ของคุณต้องตั้งเป็นอัตโนมัติ",
  get_otp_2fa_qr_code_failed: "การดึง QR code OTP 2FA ล้มเหลว กรุณาลองใหม่อีกครั้ง",
  enter_secret_manually: "กรอกรหัสลับนี้ด้วยตนเองในแอปยืนยันตัวตนของคุณ",
  otp_setup_failed: "การตั้งค่า OTP ล้มเหลว กรุณาลองใหม่อีกครั้ง",
  otp_verification_failed: "รหัสยืนยันไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
  otp_2fa_bound: "Google Authenticator ได้ถูกผูกไว้กับบัญชีของคุณสำเร็จ",
  invalid_code: "รหัสยืนยันไม่ถูกต้อง กรุณาตรวจสอบรหัสและลองใหม่อีกครั้ง",
  code_required: "กรุณากรอกรหัสยืนยัน 6 หลักจากแอปยืนยันตัวตนของคุณ",
  otp_unbind_success: "OTP ได้ถูกยกเลิกผูกไว้กับบัญชีของคุณสำเร็จ",
  otp_unbind_failed: "การยกเลิกผูก OTP 2FA ล้มเหลว กรุณาลองใหม่อีกครั้ง",
};
